import React, { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import clsx from 'clsx'
import _ from 'lodash'

function RuleDisplayBoxPlain (props) {
  const { rules, infoMessage, show, testValue } = props
  const [changeCount, setChangeCount] = useState(0)

  useEffect(() => {
    setChangeCount(changeCount + 1)
  }, [testValue])

  return (
    <AnimatePresence>
      {show && <motion.div
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0 }}
        transition={{ type: 'tween', duration: 0.3 }}>
        <div id='pr-box' className={clsx('light')}>
          <i></i>
          <div id='pr-box-inner'>
            <p>{infoMessage}</p>
            <ul>
              {
                _.map(rules, (r, i) => {
                  return <li key={`rdb_${i}`} ><span className={clsx(r.Status === true ? 'pr-ok' : '')}></span>{r.Label}</li>
                })
              }
            </ul>
          </div>
        </div>
      </motion.div>}
    </AnimatePresence>
  )
}

export const RuleDisplayBox = ({ rules, infoMessage, show, ...rest }) => { return <RuleDisplayBoxPlain rules={rules} infoMessage={infoMessage} show={show} {...rest}/> }
export default RuleDisplayBox
